import React from "react";
import api from "../../../services/api";
import { Prefix } from "../../../services/prefix";
import { mutate as globalMutate } from "swr";

export default function UpdateStatus({
  id,
  page,
  rowsPage,
  activeDefault,
  search,
  orderBy,
  order,
}) {
  let pageExact = page + parseInt(1);
  let valueSearch = !search ? "" : search;
  function HandleStatus() {
    api
      .put(Prefix.replace(/[\\"]/g, "") + "/equipment-categories/" + id, {
        active: Boolean(activeDefault === 1 ? 0 : 1),
      })
      .then(() => {
        globalMutate(
          Prefix.replace(/[\\"]/g, "") +
            "/equipment-categories?per_page=" +
            rowsPage +
            "&page=" +
            pageExact +
            "&search=" +
            valueSearch +
            "&order_by=" +
            orderBy +
            "&order=" +
            order
        );
      });
  }

  return (
    <>
      <label class="switch">
        <input
          type="checkbox"
          id={id + "equipament-categories"}
          onChange={HandleStatus}
          checked={activeDefault}
        />
        <span class="slider round"></span>
      </label>
    </>
  );
}
